import * as z from 'zod';

export const creatorSettings = z.object({
  email: z.string().email().min(1, { message: 'Required' }),
});

export type CreatorSettings = z.infer<typeof creatorSettings>;
